import { List } from "antd";
import { useEffect, useState } from "react";
import { FaCirclePlus } from "react-icons/fa6";
import { RiBuilding2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import avatar from "../../../assets/images/dummy.png";
import imagePlaceHolder from "../../../assets/images/imageplace.jpg";
import { SubmitButton, TextComponent } from "../../../components";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { phoneFormat } from "../../../utills";
import AddStaff from "./AddStaff/AddStaff";
import styles from "./BusinessProfile.module.css";
import EditBusProfileModal from "./EditBusProfileModal/EditBusProfileModal";
import EditStaff from "./EditStaff/EditStaff";
import ViewStaffProfile from "./ViewStaffProfile/ViewStaffProfile";

const BusinessProfile = () => {
  const dispatch = useDispatch();
  const [editBusinessProfile, setEditBusinessProfile] = useState(false);
  const [viewStafffProfile, setViewStaffProfile] = useState(false);
  const [editStaffModal, setEditStaffModal] = useState(false);
  const [AddStaffModal, setAddStaffModal] = useState(false);
  const [details, setDetails] = useState([]);
  const user = useSelector((state) => state.AuthReducer.user);
  const STAFF = useSelector((state) => state.AuthReducer.getStaff);

  let businessDetails = user?.company_details;
  useEffect(() => {
    dispatch(AuthMiddleware.getUserData());
    dispatch(AuthMiddleware.getStaff());
  }, []);
  const dummyStaff = [
    // {
    //   id: 1,
    //   name: "Alex Buckmaster",
    //   image: pf1,
    //   contactNo: "(917) 339-6416",
    //   email: "Chris Glasser@gmail.com",
    //   role: "Admin",
    // },
    // {
    //   id: 2,
    //   name: "Alex Buckmaster",
    //   image: pf2,
    //   contactNo: "(917) 339-6416",
    //   email: "Chris Glasser@gmail.com",
    //   role: "Assistant",
    // },
    // {
    //   id: 3,
    //   name: "Alex Buckmaster",
    //   image: pf1,
    //   contactNo: "(917) 339-6416",
    //   email: "Chris Glasser@gmail.com",
    //   role: "Admin",
    // },
    // {
    //   id: 4,
    //   name: "Alex Buckmaster",
    //   image: pf2,
    //   contactNo: "(917) 339-6416",
    //   email: "Chris Glasser@gmail.com",
    //   role: "Assistant",
    // },
  ];
  return (
    <div className={styles.mainCont}>
      {user.company_details && (
        <div className={styles.subMainCont}>
          <img
            src={
              businessDetails?.logo ? businessDetails?.logo : imagePlaceHolder
            }
            className={styles.companyImg}
          />
          <TextComponent
            className={styles.company_name}
            text={businessDetails?.name ? businessDetails?.name : "--"}
          />
          <TextComponent
            className={styles.company_desc}
            text={
              businessDetails?.service_description
                ? businessDetails?.service_description
                : "--"
            }
          />
          <TextComponent
            style={{ color: "var(--light-grey)", marginTop: "10px" }}
            text={
              businessDetails?.contact_no
                ? phoneFormat(businessDetails?.contact_no)
                : "--"
            }
          />
          <TextComponent
            style={{ color: "var(--light-grey)", marginTop: "10px" }}
            text={businessDetails?.email ? businessDetails?.email : "--"}
          />
          <TextComponent
            style={{ color: "var(--light-grey)", marginTop: "10px" }}
            text={businessDetails?.address ? businessDetails?.address : "--"}
          />
          {user.is_owner && (
            <SubmitButton
              onClick={() => setEditBusinessProfile(true)}
              style={{ marginTop: "20px" }}
              leftIcon={
                <RiBuilding2Fill
                  color={"var(--secondary-color)"}
                  style={{ marginRight: "5px" }}
                />
              }
              title={"Edit business profile"}
              secondaryBtn
            />
          )}
        </div>
      )}

      <div className={styles.subMainCont}>
        <div className={styles.staffHeader}>
          <TextComponent
            style={{
              fontSize: "var(--heading2-font-size)",
              fontFamily: "Urbanist-bold",
            }}
            text={"Staff members and Owners"}
          />
          <SubmitButton
            btnClass={styles.staff_addbtn}
            leftIcon={
              <FaCirclePlus
                // color={"var(--secondary-color)"}
                style={{ marginRight: "5px" }}
              />
            }
            title={"Add"}
            onClick={() => setAddStaffModal(true)}
          />
        </div>
        <div className={styles.listMainCont}>
          <List
            className={styles.staff_list}
            dataSource={STAFF}
            grid={{ gutter: 16, column: 2, xs: 1 }}
            renderItem={(item, index) => (
              <div className={styles.staff_listItemMain}>
                <div
                  className={styles.staff_listItem}
                  onClick={() => {
                    setViewStaffProfile(true);
                    setDetails(item);
                  }}
                >
                  <div className="flex-between">
                    <div className={styles.staff_listHeader}>
                      <img
                        src={
                          item?.profile_picture ? item?.profile_picture : avatar
                        }
                        className={styles.staff_listImage}
                      />
                    </div>
                    <TextComponent
                      className={styles.staff_listRole}
                      text={item?.role}
                    />
                  </div>

                  <TextComponent
                    style={{
                      fontFamily: "Urbanist-semibold",
                      width: "100%",
                      wordWrap: "break-word",
                      lineHeight: "1.2",
                    }}
                    text={item?.name}
                  />
                  <TextComponent
                    style={{
                      fontFamily: "Urbanist-semibold",
                      color: "var(--light-grey)",
                    }}
                    text={item?.contact_no ? phoneFormat(item?.contact_no) : ""}
                  />
                  <TextComponent
                    style={{
                      fontFamily: "Urbanist-semibold",
                      color: "var(--light-grey)",
                      width: "100%",
                      wordWrap: "break-word",
                      lineHeight: "1.2",
                    }}
                    text={item?.email}
                  />
                </div>
                {/* <img
                  src={editUser}
                  className={styles.staff_listEditUser}
                  onClick={() => {
                    setEditStaffModal(true);
                    setDetails(item);
                  }}
                /> */}
              </div>
            )}
          />
        </div>
      </div>
      <EditBusProfileModal
        editBusinessProfile={editBusinessProfile}
        setEditBusinessProfile={setEditBusinessProfile}
        businessDetails={businessDetails}
      />
      <ViewStaffProfile
        viewStafffProfile={viewStafffProfile}
        setViewStaffProfile={setViewStaffProfile}
        details={details}
        setDetails={setDetails}
        setEditStaffModal={setEditStaffModal}
      />
      <EditStaff
        editStaffModal={editStaffModal}
        setEditStaffModal={setEditStaffModal}
        details={details}
        setDetails={setDetails}
        setViewStaffProfile={setViewStaffProfile}
      />
      <AddStaff
        AddStaffModal={AddStaffModal}
        setAddStaffModal={setAddStaffModal}
      />
    </div>
  );
};

export default BusinessProfile;
